import {Component, Input, signal, inject} from '@angular/core';
import {
  NbAutocompleteModule,
  NbButtonModule,
  NbDialogRef,
  NbInputModule,
  NbOptionModule,
  NbSelectModule,
  NbSpinnerModule,
  NbToastrService
} from "@nebular/theme";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {notificationsParams} from "../../../shared/settings";
import {TicketsService} from "../../../services/tickets.service";
import {TranslateModule, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-ticket-form',
  standalone: true,
  imports: [
    TranslateModule,
    NbAutocompleteModule,
    NbButtonModule,
    NbInputModule,
    NbOptionModule,
    ReactiveFormsModule,
    NbSelectModule,
    NbSpinnerModule
  ],
  templateUrl: './ticket-form.component.html',
  styleUrl: './ticket-form.component.scss'
})
export class TicketFormComponent {
  private readonly translate = inject(TranslateService);
  loading = false;

  ticketsCategories = signal<any[]>([]);

  @Input() team_id: string = '';
  @Input() email: string = '';

  ticketForm = new FormGroup({
    consent: new FormControl(false, [Validators.required]),
    team_id: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    category_id: new FormControl('', [Validators.required]),
    title: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required]),
  });

  constructor(
    private ticketsService: TicketsService,
    private toastrService: NbToastrService,
    protected dialogRef: NbDialogRef<any>
  ) {}

  ngOnInit(): void {
    this.ticketsService.categories().subscribe((ticketsCategories: any) => {
      this.ticketsCategories.set(ticketsCategories);
      this.ticketForm.patchValue({ team_id: this.team_id });
    });
  }

  onSubmit() {
    this.loading = true;
    let submittedData: any = this.ticketForm.value;

    const ticketParams = {
      source: 'player',
      consent: submittedData.consent,
      team_id: submittedData.team_id,
      category_id: submittedData.category_id,
      email: submittedData.email,
      title: submittedData.title,
      description: submittedData.description
    };

    this.ticketsService.create(ticketParams).subscribe(() => {
      this.toastrService.success(this.translate.instant('teams.ticket.created'), this.translate.instant('common.information'), notificationsParams);
      this.dialogRef.close();
    });
  }
}
